import React from 'react';

const UnauthorizedPage = () => (
  <div>
    <h1>You are not authorized to view the content on this page</h1>
  </div>
);

export default UnauthorizedPage;
